import createWasteGroupingContractPage from '.';
import createWasteGroupingContractDetailPage from './CreateUpdate';
import { wasteGroupingContractRoutes } from './routes';

export const createWasteGroupingContractPages = () => {
  const WasteGroupingContract = createWasteGroupingContractPage();
  const AddWasteGroupingContract = createWasteGroupingContractDetailPage();
  const UpdateWasteGroupingContract = createWasteGroupingContractDetailPage();

  const WasteGroupingContractPage = wasteGroupingContractRoutes;
  return () => (
    <WasteGroupingContractPage WasteGroupingContract={WasteGroupingContract} AddWasteGroupingContract={AddWasteGroupingContract} UpdateWasteGroupingContract={UpdateWasteGroupingContract} />
  );
};

